import * as React from "react";
import {getFilesSize} from "./memberFormSlice";
import {useRef} from "react";
import {CloseIcon} from "../ui/icons/icons";

const MemberFormFilesInput = (props: {uploadedFiles: FileList, setUploadedFiles: (uploadedFiles: FileList) => void}) => {

  const {uploadedFiles, setUploadedFiles} = props;
  const fileInput = useRef();

  const filesSize = getFilesSize(uploadedFiles);

  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUploadedFiles(event.currentTarget.files);
  }

  const removeFile = (fileIndex: number) => {
    if (fileInput?.current) {
      console.log("file.file", fileIndex);
      console.log("fileInput.current", fileInput.current);
      const dt = new DataTransfer();
      for (let i = 0; i < uploadedFiles.length; i++) {
        const file = uploadedFiles[i]
        if (fileIndex !== i) {
          dt.items.add(file) // here you exclude the file. thus removing it.
        }
      }
      // @ts-ignore
      fileInput.current.files = dt.files;
      setUploadedFiles(dt.files);
    }
  }
  // console.log("uploadedFiles", uploadedFiles);

  return (
    <div className="member-item">
      <div className="flex flex--start member-item__title">
        <span className="member-item__icon member-item__icon--number">1</span>
        <span className="h4">Submit your photos and videos for expert editing.</span>
      </div>
      <div className="flex flex--evenly">
        <input
          ref={fileInput}
          className="ui-input--hidden"
          type="file"
          multiple
          id="uploadFiles"
          name="uploadFiles"
          // accept='image/png, image/jpeg'
          onChange={handleChangeInput}
          // value={photo}
        ></input>
        <div className="ui-input__label">
          <label className="ui-button ui-button--darkblue2 medium" htmlFor="uploadFiles">
            {uploadedFiles && uploadedFiles.length
              ? (uploadedFiles.length === 1 ? "1 File" : uploadedFiles.length + " files")
              : "+Choose file"}
          </label>
          {filesSize > 25 ? (
            <span className="ui-input__label-error red block">Max file size limit is 25 Mb</span>
          ) : null}
        </div>
        {uploadedFiles && uploadedFiles.length ? (
          <ul className="ul margin-0">
            {[].slice.call(uploadedFiles).map((file: File, fileIndex: number) => {
              return (
                <li className="li gray5 medium" key={file.name + file.lastModified}>
                  {file.name} {`(${Math.round(file.size / 1024 / 1024 * 1000) / 1000} Mb)`}
                  <button className="ui-close--delete" onClick={() => removeFile(fileIndex)}>
                    <CloseIcon/>
                  </button>
                </li>
              )
            })}
          </ul>
        ) : <span className="gray5 medium">No files chosen</span>}
      </div>
    </div>
  )
}

export default MemberFormFilesInput
